import { render } from "./Index.vue?vue&type=template&id=0156252e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=0156252e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0156252e"

export default script